import { supplierIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

const RecommendedProductSchema_ = z.object({
  productId: productIdFormat.schema,
  quantity: z.number().int().min(0),
  unitCost: z.number().min(0),
  unitCostCurrency: z.string(),
  unitPrice: z.number().min(0).nullable(),
  unitsPerBox: z.number().int().positive().nullish(),
});
export const RecommendedProductSchema: z.ZodType<RecommendedProduct> =
  RecommendedProductSchema_;
export interface RecommendedProduct extends z.infer<
  typeof RecommendedProductSchema_
> {}

const SupplierRecommendationSchema_ = z.object({
  supplierId: supplierIdFormat.schema,
  supplierName: z.string(),
  totalCost: z.number().min(0),
  totalProfit: z.number().nullable(),
  skuCount: z.number().int().min(0),
  totalUnits: z.number().int().min(0),
  products: z.array(RecommendedProductSchema),
});
export const SupplierRecommendationSchema: z.ZodType<SupplierRecommendation> =
  SupplierRecommendationSchema_;
export interface SupplierRecommendation extends z.infer<
  typeof SupplierRecommendationSchema_
> {}

export const getRecommendedPurchaseOrders = {
  name: "getRecommendedPurchaseOrders" as const,
  input: z.null(),
  output: z.object({
    recommendations: z.array(SupplierRecommendationSchema),
    currency: z.string(),
  }),
};
